import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckContent } from "@/features/dashboard/caminhoes/components/TruckContent";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Caminhão" from="/dashboard/caminhoes/editar/$id">
      <TruckContent />
    </BaseEditCreateModal>
  );
}
